// Models
import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';
import {
  T_PERSON_TRANSACTION_MY_CLIENT_SCHEMA,
  T_PERSON_TRANSACTION_RAW_INPUTS_SCHEMA,
} from 'app/modules/goAML/schemas/tPersonTransactionSchema';

// Utils
import { required } from 'app/shared/utils/validation';

// Constants
import { ENTITY_PERSON_ROLE_TYPE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/entityPersonRoleType';

export const DIRECTOR_ROLE_FIELD: FormFieldSchema<string> = {
  label: 'Role',
  name: 'role',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: ENTITY_PERSON_ROLE_TYPE_OPTIONS,
  },
  required: true,
  validate: required('Role is required.'),
  default: 'D',
};

export const DIRECTOR_ID_RAW_INPUTS = [DIRECTOR_ROLE_FIELD];

// Schemas
export const DIRECTOR_ID_SCHEMA = [
  ...DIRECTOR_ID_RAW_INPUTS,
  ...T_PERSON_TRANSACTION_RAW_INPUTS_SCHEMA,
];
export const DIRECTOR_ID_MY_CLIENT_SCHEMA = [
  ...DIRECTOR_ID_RAW_INPUTS,
  ...T_PERSON_TRANSACTION_MY_CLIENT_SCHEMA,
];
